

































































































































































import { Component, Vue } from 'vue-property-decorator'
import fetch from '@/utils/fetch'
import moment from 'moment'
import { SchoolController } from '@/services/request.service'

@Component
export default class ViewSchool extends Vue {
  private school: any = {}
  private mibpData: Array<any> = []
  private descriptionExpand = false

  private moment = moment

  private get locale(): string {
    return this.$store.state.locale
  }

  private get hasAssessment(): boolean {
    if (this.school.features) {
      const features = this.school.features.map(feature => feature.featureCode)
      return features.includes('ASSSHEET') || features.includes('ASSREPOT')
    } else {
      return false
    }
  }

  private get mibpColumns(): Array<any> {
    return [
      {
        title: this.$tc('schoolMgmt.section'),
        dataIndex: 'sectionName',
      },
      {
        title: this.$tc('schoolMgmt.bookSeries'),
        scopedSlots: {
          customRender: 'bookSeries',
        },
      },
      {
        title: this.$tc('schoolMgmt.subscribedNum'),
        dataIndex: 'orderNum',
      },
    ]
  }

  private created(): void {
    this.getSchoolInfo()
  }

  private toggleDescriptionExpand(): void {
    this.descriptionExpand = !this.descriptionExpand
  }

  private getSchoolInfo(): void {
    const schoolId = parseInt(this.$route.params.schoolId, 10)
    SchoolController.detail(schoolId)
      .then(res => {
        const features = res.data.features.map(feature => feature.featureName).join('、')
        this.school = {
          ...res.data,
          featuresText: features.length > 35 ? features.slice(0, 35) + '...' : features,
        }
        this.mibpData = res.data.pictureBooks.map((book, index) => {
          return {
            ...book,
            index,
          }
        })
      })
      .catch(err => {
        console.warn(err)
      })
  }
}
